<template lang="pug">
md-layout(md-column='', md-align='start')
  md-theme(md-name='brown-white')
    // Title
    breadcrumbs(section='Reporting', :nav='nav')

  md-theme(md-name='blue')
    // Reports List
    report-table
</template>

<script>
  import { mapState } from 'vuex';
  import ReportTable from '../../shared-components/report/ReportTable';
  import Breadcrumbs from '../../shared-components/Breadcrumbs';

  export default {
    components: {
      ReportTable,
      Breadcrumbs
    },
    computed: {
      ...mapState({
        useraccount: state => state.user.useraccount,
        siteuser: state => state.user.siteuser
      }),
      nav() {
        return [
          { title: 'Views'}
        ]
      }
    }
  };
</script>

<style lang="scss">
  .on-left {
    margin-top: -5px;
    margin-right: 5px;
  }
</style>



// WEBPACK FOOTER //
// src/spa/reporting/Reports.vue